export default "__VITE_ASSET__CkoZ_Jdr__"